const initialState = {
    drivesDetail: {}
  }
  
  export default (state = initialState, action) => {
    switch (action.type) {
      case 'SET_DRIVES_DETAILS':
        return {
          ...state,
          drivesDetail: action.data,
        }
      default:
        return state
    }
  }